module.exports = __webpack_public_path__ + "static/img/tab2.b4bfb38d.jpg";